import React, { useState, useEffect } from "react";

export function Tweaks() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      if (!e.data || typeof e.data !== "object") return;
      if (e.data.type === "__activate_edit_mode") {
        setActive(true);
        document.body.classList.add("tweaks-on");
      }
      if (e.data.type === "__deactivate_edit_mode") {
        setActive(false);
        setOpen(false);
        document.body.classList.remove("tweaks-on", "tweaks-open");
      }
    };
    window.addEventListener("message", handler);
    window.parent.postMessage({type:"__edit_mode_available"}, "*");
    return () => window.removeEventListener("message", handler);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("tweaks-open", open);
  }, [open]);

  const apply = (k, v) => {
    const body = document.body;
    const attr = ({theme:"data-theme", density:"data-density", palette:"data-palette", type:"data-type", layout:"data-layout"})[k];
    if (attr) body.setAttribute(attr, v);
    // Mirror theme onto <html> too so the legacy Django report pages
    // (which key their CSS off html[data-theme="dark"]) stay in sync.
    if (k === "theme") {
      document.documentElement.setAttribute("data-theme", v);
    }
    // Persist to localStorage so the pre-paint script in spa.html picks
    // it up on the next page load.
    try { localStorage.setItem("vz-" + k, v); } catch { /* ignore */ }
    window.__TWEAKS__ = { ...window.__TWEAKS__, [k]: v };
    window.parent.postMessage({type:"__edit_mode_set_keys", edits:{[k]: v}}, "*");
  };

  // Apply initial from __TWEAKS__ on mount
  useEffect(() => {
    const t = window.__TWEAKS__ || {};
    Object.entries(t).forEach(([k,v]) => apply(k, v));
  }, []);

  if (!active) return null;

  const t = window.__TWEAKS__ || {};

  const Seg = ({k, options}) => (
    <div className="seg">
      {options.map(o => (
        <button key={o.v} className={t[k] === o.v ? "on" : ""} onClick={() => { apply(k, o.v); setOpen(o=>o); }}>
          {o.l}
        </button>
      ))}
    </div>
  );

  return (
    <>
      <button className="tweaks-fab" onClick={()=>setOpen(o=>!o)}>
        <span>Tweaks</span>
      </button>
      <div className="tweaks-panel">
        <h3>Tweaks</h3>
        <div className="hint">Live preview — persisted to disk.</div>

        <div className="tweaks-row">
          <label>Theme</label>
          <Seg k="theme" options={[{v:"dark",l:"Dark"},{v:"light",l:"Light"}]}/>
        </div>
        <div className="tweaks-row">
          <label>Palette</label>
          <div className="swatches">
            {[
              {v:"verdigris", c:"#4A8F7C"},
              {v:"indigo", c:"#3B3B9E"},
              {v:"ultramarine", c:"#3D5AA8"},
              {v:"cinnabar", c:"#B44A34"},
              {v:"graphite", c:"#2A2F36"},
            ].map(s => (
              <div key={s.v}
                   className={"swatch" + (t.palette === s.v ? " on" : "")}
                   style={{background:s.c}}
                   onClick={()=>apply("palette", s.v)}/>
            ))}
          </div>
        </div>
        <div className="tweaks-row">
          <label>Type</label>
          <Seg k="type" options={[{v:"editorial",l:"Editorial"},{v:"modern",l:"Modern"},{v:"technical",l:"Technical"}]}/>
        </div>
        <div className="tweaks-row">
          <label>Density</label>
          <Seg k="density" options={[{v:"compact",l:"Compact"},{v:"regular",l:"Regular"},{v:"roomy",l:"Roomy"}]}/>
        </div>
        <div className="tweaks-row">
          <label>Layout</label>
          <Seg k="layout" options={[{v:"sidebar",l:"Sidebar"},{v:"compact-rail",l:"Rail"},{v:"no-sidebar",l:"None"}]}/>
        </div>
      </div>
    </>
  );
}
